/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteCaptureLabelRequest
 */
export interface DeleteCaptureLabelRequest {
    /**
     * 
     */
    labelId: string;
}

/**
 * Check if a given object implements the DeleteCaptureLabelRequest interface.
 */
export function instanceOfDeleteCaptureLabelRequest(value: object): value is DeleteCaptureLabelRequest {
    if ((!('labelId' in (value as Record<string, any>)) && !('label_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['labelId'] === undefined && (value as Record<string, any>)['label_id'] === undefined)) return false;
    return true;
}

export function DeleteCaptureLabelRequestFromJSON(json: any): DeleteCaptureLabelRequest {
    return DeleteCaptureLabelRequestFromJSONTyped(json, false);
}

export function DeleteCaptureLabelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteCaptureLabelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'labelId': json['label_id'],
    };
}

export function DeleteCaptureLabelRequestToJSON(json: any): DeleteCaptureLabelRequest {
    return DeleteCaptureLabelRequestToJSONTyped(json, false);
}

export function DeleteCaptureLabelRequestToJSONTyped(value?: DeleteCaptureLabelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label_id': value['labelId'],
    };
}

